import React, { useMemo } from 'react';
import { FlagProvider, useFlags, useFlagsStatus } from '@unleash/proxy-client-react';
import { FeatureToggleContext } from '../../services/contexts/FeatureToggleContext';

const config = {
  url: process.env.REACT_APP_UNLEASH_URL as string,
  clientKey: process.env.REACT_APP_UNLEASH_AUTHORIZATION as string,
  refreshInterval: 300,
  appName: 'mss',
};

const FeatureToggleProvider = ({ children }) => {
  const toggles = useFlags();
  const { flagsReady, flagsError } = useFlagsStatus();

  const value = useMemo(() => {
    if (toggles) {
      return { result: toggles };
    }
    if (!flagsReady) {
      return { loading: true };
    }
    if (flagsError) {
      return { error: flagsError };
    }
    return { result: [] };
  }, [flagsError, flagsReady, toggles]);

  return <FeatureToggleContext.Provider value={value}>{children}</FeatureToggleContext.Provider>;
};

export const UnleashProvider = ({ children }) => {
  return (
    <FlagProvider config={config}>
      <FeatureToggleProvider>{children}</FeatureToggleProvider>
    </FlagProvider>
  );
};
